export default class ValidateChip {
  existsChip: boolean

  constructor(data: any = {}) {
    this.existsChip = data.existsChip
  }
}
